export const tickerMatchKey = (value: string): string =>
  value.trim().replace(/^\$/, '').replace(/[./]/g, '-').toUpperCase();

export const queryForSymbolSearch = (query: string): string => {
  const trimmed = query.trim();
  return trimmed.startsWith('$') ? trimmed.slice(1).trim() : trimmed;
};

export const findExactTicker = <T extends { symbol?: string | null }>(
  query: string,
  tickers: readonly T[],
): T | undefined => {
  const key = tickerMatchKey(query);
  if (!key) return undefined;
  return tickers.find(ticker => !!ticker.symbol && tickerMatchKey(ticker.symbol) === key);
};

export type HeaderSearchEnter<T extends { symbol?: string | null }> =
  | { kind: 'selection' }
  | { kind: 'none' }
  | { kind: 'quote'; ticker: T }
  | { kind: 'search'; query: string };

export const resolveHeaderSearchEnter = <T extends { symbol?: string | null }>(
  query: string,
  highlightedIndex: number,
  tickers: readonly T[],
): HeaderSearchEnter<T> => {
  if (highlightedIndex >= 0) return { kind: 'selection' };
  const trimmed = query.trim();
  if (!trimmed) return { kind: 'none' };
  const ticker = findExactTicker(trimmed, tickers);
  if (ticker) return { kind: 'quote', ticker };
  return { kind: 'search', query: trimmed };
};
